require("-!style!css!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Panel.vue")
module.exports = require("-!babel?optional[]=runtime!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Panel.vue")
module.exports.template = require("-!vue-html!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Panel.vue")



/*****************
 ** WEBPACK FOOTER
 ** ./src/Panel.vue
 ** module id = 116
 ** module chunks = 0
 **/